export default __webpack_public_path__ + "static/media/Vector.638c60dd.png";